module.exports = __webpack_public_path__ + "img/setor-criativo-acao-camisetas.d19648e5.png";